import { useEffect, useState } from "react";
import { useRouter } from "next/router";
import { REGION_COOKIE_NAME } from "store/location";
import { getClientCookie } from "helpers/cookies";
import { DEFAULT_REGION_CODE } from "constants/variables";

export const useHomeUrl = (): string => {
  const { query } = useRouter();
  const [url, setUrl] = useState("/");

  useEffect(() => {
    const cookieRegion: Entity.Region = getClientCookie(
      REGION_COOKIE_NAME
    ) as Entity.Region;
    const region = query.region || cookieRegion?.id;
    const isDefault =
      !region ||
      String(region).toLowerCase() === DEFAULT_REGION_CODE.toLowerCase();

    setUrl(isDefault ? "/" : `/r_${region}/`);
  }, [query.region]);

  return url;
};

export default useHomeUrl;
